import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setIsProcessingPayment } from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';

export const useBuyNowClearPaymentMethod = () => {
  const dispatch = useDispatch();

  const clearPayment = useCallback(() => {
    dispatch(setIsProcessingPayment(false));
  }, [dispatch]);

  return { clearPayment };
};
